import React, { useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

const RestrictedModeAlert = () => {
  const [show, setShow] = useState(true);

  if (!show) return null;

  return (
    <Alert
      variant="warning"
      dismissible
      onClose={() => setShow(false)}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1050,
        maxWidth: '350px',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <FontAwesomeIcon icon={faLock} style={{ marginRight: '10px', fontSize: '1.5em', color: '#856404' }} />
        <strong>Περιορισμένη λειτουργία!</strong>
        <div>
          <p style={{ marginBottom: '0.5rem', marginTop: '0.5rem' }}>
            Έχετε συνδεθεί με περιορισμένη λειτουργία. Επικοινωνήστε με τον διαχειριστή για να αλλάξετε την κατάστασή σας.
          </p>
        </div>
      </div>
      <Button
        onClick={() => setShow(false)}
        variant="outline-secondary"
        size="sm"
        style={{ marginTop: '10px', display: 'block', width: '100%' }}
      >
        Κλείσιμο
      </Button>
    </Alert>
  );
};

export default RestrictedModeAlert;
